// @dynamic-i18n-keys
// siteHeader.deviation
// siteHeader.statusUpdate
// siteHeader.journal
// siteHeader.literature
// siteHeader.commission
// siteHeader.poll
// siteHeader.tier
// siteHeader.dreamup
// siteHeader.originals
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { ModalType, ModalOptions } from '../../../../../Modals/redux/types';
import { VerificationRequiredActions } from '../../../../../publicSession/types';
import { useSubmitMenuItem } from '../../../../hooks/useSubmitMenuItem';
import { sanitizeHref } from "@wix/da-url";

import s from './SubmitMenuItem.scss';

interface Props {
  type: string;
  label: string;
  modalType?: ModalType;
  modalOptions?: ModalOptions;
  link?: string;
  target?: string;
  verificationAction?: VerificationRequiredActions;
  className?: string;
  isNew?: boolean;
  openInStudio?: boolean;
}

const SubmitMenuItem: React.FC<Props> = ({
  className,
  type,
  modalType,
  modalOptions,
  label,
  link,
  target,
  verificationAction,
  openInStudio,
}) => {
  const { t } = useTranslation();

  const { onClick, href, biData } = useSubmitMenuItem({
    modalType,
    link,
    verificationAction,
    type,
    modalOptions,
    openInStudio,
  });

  return (
    <PlainButtonOrLink
      className={classnames(s['submit-menu-item'], className)}
      href={sanitizeHref(href)}
      target={target}
      tabIndex={0}
      onClick={onClick}
      biData={biData}
      isFakeButton={!onClick}
    >
      {t(label)}
    </PlainButtonOrLink>
  );
};
SubmitMenuItem.displayName = 'SubmitMenuItem';

export default SubmitMenuItem;
